import { CLIENTS } from "@/lib/siteData";

export const ClientMarquee = () => {
  // Duplicate list for seamless loop
  const loop = [...CLIENTS, ...CLIENTS];

  return (
    <section
      id="clients"
      data-testid="client-logo-marquee-section"
      className="relative border-y border-border bg-background"
    >
      <div className="container-site py-10 sm:py-14">
        <div className="flex items-center justify-between mb-6 sm:mb-8">
          <p className="kicker">Trusted by -</p>
          <p className="text-xs uppercase tracking-[0.22em] text-muted-foreground hidden sm:block">
            Selected clients
          </p>
        </div>
      </div>
      <div data-testid="client-logo-marquee" className="relative overflow-hidden mask-fade-x marquee-pause pb-12 sm:pb-16">
        <div className="marquee-track gap-12 sm:gap-16 px-6">
          {loop.map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              data-testid={`client-logo-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex h-16 sm:h-20 w-32 sm:w-40 items-center justify-center shrink-0 grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
              title={c.name}
            >
              <img
                src={c.logo}
                alt={`${c.name} logo`}
                className="max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
